import { AuroraCanvas } from "@/components/AuroraCanvas";
import { Sparkles, Phone, Repeat, FileText, Check, ArrowRight } from "lucide-react";

const CHAT = [
    { me: true, t: "I want to open a car-detailing business next year." },
    { me: false, t: "Great goal. Let's map it: structure, setup steps, and what to prepare before funding conversations." },
    { me: true, t: "Where do I start?" },
    { me: false, t: "Start with a free roadmap. I'll outline steps you can review with our team in a consultation." },
];
const FLOW = [
    { I: Phone, t: "Smarter Reception", d: "Capture and route inquiries" },
    { I: Repeat, t: "Smarter Follow-Up", d: "Timely, approved follow-ups" },
    { I: FileText, t: "Smarter Documents", d: "Organize and prepare paperwork" },
];

export function SIShowcase({ onTalk, onAutomation }) {
    return (
        <section id="si" className="si-navy-band relative overflow-hidden px-5 py-24 text-white lg:px-8 lg:py-32" data-testid="si-showcase">
            <img src="https://images.unsplash.com/photo-1554208791-ff69f8454d1b?crop=entropy&cs=srgb&fm=jpg&q=70&w=1600" alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-[0.14] mix-blend-luminosity" aria-hidden="true" />
            <AuroraCanvas dark className="opacity-90" />
            <div className="si-navy-glow" aria-hidden="true" />
            <div className="si-gridlines si-gridlines-dark" aria-hidden="true" />
            <div className="si-orbit" aria-hidden="true" />
            <div className="relative mx-auto grid max-w-7xl gap-14 lg:grid-cols-[1fr_1.1fr] lg:items-center">
                <div className="reveal">
                    <div className="si-eyebrow !text-teal-light">Smarter Intelligence</div>
                    <h2 className="mt-4 font-display text-4xl font-semibold leading-[1.05] tracking-[-0.035em] sm:text-5xl">An intelligent guide, <span className="font-serif-accent text-teal-light">built in.</span></h2>
                    <p className="mt-5 max-w-lg text-lg leading-relaxed text-slate-300">SI helps you plan next steps and helps businesses streamline routine work — reception, follow-up, and documents — with a human review step.</p>
                    <ul className="mt-8 space-y-3">
                        {["Free business-launch roadmap", "Workflows that act only within your authorization", "Human review before anything is sent"].map((t) => (
                            <li key={t} className="flex items-center gap-3 text-[15px] text-slate-200"><span className="flex h-5 w-5 items-center justify-center rounded-full bg-teal/20"><Check className="h-3 w-3 text-teal-light" /></span>{t}</li>
                        ))}
                    </ul>
                    <div className="mt-10 flex flex-col gap-3 sm:flex-row">
                        <button onClick={onTalk} data-testid="si-showcase-talk" className="si-btn-primary">Talk to SI <ArrowRight className="h-4 w-4" /></button>
                        <button onClick={onAutomation} data-testid="si-showcase-automation" className="si-btn-ghost-dark">Explore automation</button>
                    </div>
                </div>

                <div className="reveal relative" style={{ "--d": "120ms" }} aria-hidden="true">
                    <div className="si-glass-dark rounded-3xl p-5 sm:p-6">
                        <div className="flex items-center gap-2 border-b border-white/10 pb-4">
                            <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-gradient-to-br from-ocean to-teal text-[10px] font-extrabold">SI</span>
                            <div className="text-sm font-semibold">SI Assistant</div>
                            <span className="ml-auto rounded-full bg-white/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-slate-300">Illustrative</span>
                        </div>
                        <div className="space-y-3 py-5">
                            {CHAT.map((m, i) => (
                                <div key={i} className={`si-chat-msg flex ${m.me ? "justify-end" : "justify-start"}`} style={{ "--i": i }}>
                                    <div className={`max-w-[82%] rounded-2xl px-4 py-2.5 text-[13px] leading-relaxed ${m.me ? "rounded-br-md bg-ocean text-white" : "rounded-bl-md bg-white/10 text-slate-100"}`}>{m.t}</div>
                                </div>
                            ))}
                            <div className="si-typing flex gap-1 pl-2"><span /><span /><span /></div>
                        </div>
                        <div className="grid gap-2.5 border-t border-white/10 pt-5 sm:grid-cols-3">
                            {FLOW.map(({ I, t, d }, i) => (
                                <div key={t} className="si-flow-node rounded-xl border border-white/10 bg-white/[0.04] p-3" style={{ "--i": i }}>
                                    <I className="h-4 w-4 text-teal-light" />
                                    <div className="mt-2 text-xs font-semibold">{t}</div>
                                    <div className="mt-0.5 text-[11px] text-slate-400">{d}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="si-glass-dark absolute -right-3 -top-6 hidden items-center gap-2 rounded-xl px-3 py-2 text-xs sm:flex"><Sparkles className="h-3.5 w-3.5 text-teal-light" /> Human review on</div>
                </div>
            </div>
        </section>
    );
}
